export default {
  name: "author-section",
  props: {
    number: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    lead: {
      type: String,
      default: "",
    },
    isStacked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedNumber() {
      return String(this.number).padStart(2, "0");
    },
  },
};
